import React from 'react';
import { styled } from 'styled-components';
import { getTextColorByBackgroundColor } from '@/utils/utils';

const StyledToolTip = styled.div`
  display: flex;
  align-items: center;
  cursor: initial;
  & > div {
    min-width: 50px;
    position: relative;
    white-space: pre;
    color: ${(props) => getTextColorByBackgroundColor(props.$color)};
    padding: 12px 12.8px;
  }
  & > div:before {
    position: absolute;
    z-index: -1;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: ${(props) => props.$color};
    border-radius: 5px;
    content: '';
  }
  &:after {
    margin: 0 20px;
    border: 10px solid transparent;
    content: '';
  }
  &.top {
    bottom: 100%;
    flex-direction: column;
    &:after {
      border-top: 20px solid ${(props) => props.$color};
      margin-bottom: calc(${(props) => props.$gap}-10px);
    }
  }
  &.bottom {
    top: 100%;
    flex-direction: column-reverse;
    &:after {
      border-bottom: 20px solid ${(props) => props.$color};
      margin-top: calc(${(props) => props.$gap}-10px);
    }
  }
  &.left {
    right: 100%;
    flex-direction: row;
    &:after {
      border-left: 20px solid ${(props) => props.$color};
      margin-right: calc(${(props) => props.$gap}-10px);
    }
  }
  &.right {
    left: 100%;
    flex-direction: row-reverse;
    align-items: center;
    &:after {
      border-right: 20px solid ${(props) => props.$color};
      margin-left: calc(${(props) => props.$gap}-10px);
    }
  }
`;

/**
 * @param {Object} props 툴팁 속성
 * @param {string} [props.position='top'] children 기준으로 툴팁의 위치 (옵션)
 * @param {string} [props.gap ] 툴팁과의 간격
 * @param {string} [props.color='dimgray'] 툴팁의 배경 색상 (옵션)
 * @param {React.ReactNode} props.children - 툴팁의 내용으로 표시할 ReactNode (필수)
 * @returns {JSX.Element} JSX 요소를 반환합니다.
 */
const ToolTip = ({ position = 'top', gap, color = 'dimgray', children }) => {
  return (
    <StyledToolTip className={`tooltip ${position}`} $gap={gap} $color={color}>
      <div>{children}</div>
    </StyledToolTip>
  );
};

export default ToolTip;
